import state from "@/modules/school/store/staff/group/membership/in/state";
import ApiService from "@/core/services/api.service";

function extracted() {
  console.log("List", state.items);

  let school_employee = [];
  state.items.forEach((em) => {
    console.log(em);
    if (em.selected) {
      school_employee.push(em.id);
    }
  });
  console.log(school_employee);
  return school_employee;
}

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteStaffGroupMembers(context, payload) {
    const school_employee = extracted();
    console.log("Deleting: ", school_employee);

    ApiService.setHeader();
    return ApiService.delete("school/group/employees", {
      params: {
        school_employee: school_employee,
        id: payload.id,
      },
    }).then((response) => response);
  },
};
export default {
  state,
  actions,
};
